export const fetchTimeSheetTree = data => ({
  type: "FETCH_TIME_SHEET_TREE",
  payload: data
});

export const initTimeSheetTree = () => ({
  type: "INIT_TIME_SHEET_TREE"
});

export const initTimeSheet = () => ({
  type: "INIT_TIME_SHEET"
});

export const initTimeSheetAttachment = () => ({
  type: "INIT_TIME_SHEET_ATTACHMENT"
});

export const setTimeSheetAttachment = timeSheetAttachment => ({
  type: "SET_TIME_SHEET_ATTACHMENT",
  timeSheetAttachment
});

export const setSourceModel = sourceModel => ({
  type: "SET_TIME_SHEET_SOURCE_MODEL",
  sourceModel
});

export const setCycleCombination = combination => ({
  type: "SET_CYCLE_COMBINATION",
  combination
});

export const saveTimeSheet = resp => ({
  type: "SAVE_TIME_SHEET",
  payload: resp
});

export const setTimeSheetSearchWord = searchWord => {
  return {
    type: "SET_TIME_SHEET_SEARCH_WORD",
    searchWord
  };
};

export const exportPeriodTimeSheet = data => ({
  type: "EXPORT_TIME_SHEET",
  payload: data
});



// WEBPACK FOOTER //
// ./src/actions/actions/time-sheet.js